import { patreonStatusQueryOptions } from "@/api/fapinstructor/patreon/get-patreon-status";
import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_subscribed")({
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(patreonStatusQueryOptions()),
  component: RouteComponent,
});

function RouteComponent() {
  const patreonStatus = Route.useLoaderData();
  const currentMembershipTier = patreonStatus.membershipTier ?? "free";

  // Redirect to sign-up page for free members.
  if (currentMembershipTier === "free") {
    return <Navigate to="/pricing" />;
  }

  return <Outlet />;
}
